import React, { useEffect } from "react";
import { Link } from "react-router-dom";

type BannerProps = {
  backgroundClass?: string;
  apiImage?: string;
  bannerImage?: string;
  videoSrc?: string;
  overlayVideo?: string;
  mainHeading?: string;
  subHeading?: string;
  customClass?: string;
  buttonText?: string;
  buttonIcon?: string;
  buttonOnClick?: () => void;
  buttonLink?: string;
  buttonTextTwo?: string;
  buttonIconNew?: string;
  buttonOnClickNew?: () => void;
  buttonLinkTwo?: string;
  category?: string;
};

const Banner: React.FC<BannerProps> = React.memo((props) => {
  const {
    backgroundClass = "bg-teal",
    apiImage,
    bannerImage,
    videoSrc,
    overlayVideo,
    mainHeading,
    subHeading,
    customClass,
    buttonText,
    buttonIcon,
    buttonOnClick,
    buttonLink,
    buttonTextTwo,
    buttonIconNew,
    buttonOnClickNew,
    buttonLinkTwo,
    category,
  } = props;

  // No forced reflows: removed offsetWidth etc
  useEffect(() => {
    if (apiImage) console.log("Banner rendered with apiImage:", apiImage);
  }, [apiImage]);

  const renderMedia = () => {
    if (apiImage) {
      return (
        <img
          src={`${process.env.REACT_APP_LOCAL_URL}/${apiImage.replace(/\\/g, "/")}`}
          alt={mainHeading}
          className="w-full aspect-[16/9] object-cover"
          loading="eager"
          fetchPriority="high"
        />
      );
    }
    if (bannerImage) {
      return (
        <img
          src={bannerImage}
          alt={mainHeading}
          className="w-full aspect-[16/9] object-cover "
          loading="eager"
          fetchPriority="high"
        />
      );
    }
    if (videoSrc) {
      return (
        <video
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          className="w-full aspect-[16/9] object-cover"
        >
          <source src={videoSrc} type="video/mp4" />
        </video>
      );
    }
    return null;
  };

  return (
    <section className={`${backgroundClass} sm:pb-0`}>
      <div className="flex flex-col items-center sm:relative   xl:h-[90dvh] xl:h-screen overflow-hidden">
        {renderMedia()}
        {overlayVideo && <div className={overlayVideo} />}

        <div
          className={`blade-bottom-padding blade-top-padding sm:absolute sm:bottom-2 sm:flex sm:flex-col sm:items-center sm:justify-center sm:text-center sm:space-y-2 sm:px-4 ${
            category === "resources" ? "mb-8" : "sm:blade-bottom-margin-sm"
          } relative text-center px-4 overflow-hidden`}
        >
          {mainHeading && (
            <h1
              className="text-pear font-lato-bold sm:mt-0"
              dangerouslySetInnerHTML={{ __html: mainHeading }}
            />
          )}
          {subHeading && (
            <h3 className={`mt-4 px-4 text-white font-lato-regular sm:mt-0 ${customClass}`}>
              {subHeading}
            </h3>
          )}

          <div className={`sm:flex mt-4 ${category === "impact" ? "lg:gap-16 md:gap-4 gap-8 me-5 sm:me-0" : "lg:gap-4 gap-4"}`}>
            {buttonText && buttonLink && (
              <Link to={buttonLink} className="mx-auto mt-6  group">
                <button
                  className={`mx-auto border-2 border-pear group-hover:bg-transparent group-hover:text-white flex gap-2 transition-all duration-500 bg-pear sm:px-14 px-8 py-2 text-black font-lato-bold sm:gap-4 ${
                    category === "impact" ? "lg:px-5 px-4" : ""
                  } sm:py-3 2xl:text-2xl lg:text-lg text-base`}
                  onClick={buttonOnClick}
                >
                  {buttonText}
                  {buttonIcon && (
                    <svg
                      className="h-auto 2xl:h-9 group-hover:translate-x-3 transition-all duration-500"
                      width="8"
                      height="15"
                      viewBox="0 0 9 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d={buttonIcon} fill="black" className="transition-all duration-300 group-hover:fill-white" />
                    </svg>
                  )}
                </button>
              </Link>
            )}

            {buttonTextTwo && buttonLinkTwo && (
             

              <Link to={buttonLinkTwo} className="flex justify-center h-fit mt-4  mx-auto sm:mt-auto w-fit">
                <button
                  className="border-pear  flex gap-2 border-2 py-3 px-8 text-pear font-lato-bold sm:gap-2 2xl:text-2xl lg:text-lg text-base hover:bg-teal hover:text-white transition-all duration-500"
                  onClick={buttonOnClickNew}
                >
                  {buttonTextTwo}
                  {buttonIconNew && (
                    <svg
                      className="h-auto 2xl:h-9 transition-all duration-500"
                      width="8"
                      height="15"
                      viewBox="0 0 10 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d={buttonIconNew} fill="#D7DF23" className="fill-current hover:fill-black transition-all duration-300" />
                    </svg>
                  )}
                </button>
              </Link>
            )}
          </div>
        </div>
      </div>
    </section>
  );
});

export default Banner;
